module.exports = __webpack_public_path__ + "static/media/icon_news_blue.06c44379.svg";